import { ENDPOINT } from '~/constants/endpoints';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type UsersAdminQueryParams, type UsersAdminResponse } from './types';
import { zodUsersAdminQueryParamsSchema } from './validations';

/**
 * Fetches all users with given query parameters an ADMIN has access to.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin/operation/get_users_vadmin_users_get
 */
export const fetchUsersAdmin = async (
  searchParams: Partial<UsersAdminQueryParams> = {},
) => {
  try {
    const response = await vestigasApi
      .get(ENDPOINT.USER.GET_ALL_ADMIN(), {
        searchParams,
        validate: { searchParams: zodUsersAdminQueryParamsSchema },
      })
      .json<UsersAdminResponse>();

    return (
      response ?? {
        data: [],
        hasNextPage: false,
        paginatedCount: 0,
        totalCount: 0,
      }
    );
  } catch (error) {
    log.error({
      message: 'Error fetching users',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(($) => $.user.fetchUsersAdmin.error422, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(($) => $.user.fetchUsersAdmin.error.generic, {
            ns: 'data',
          });
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
